export enum ServiceMode {
  On = 'On',
  UsersOff = 'UsersOff'
}

export interface IServiceMode {
  mode: ServiceMode;
}
